import Menu from './menu';

class Header {
  constructor() {
    const that = this;

    // Instance imports
    new Menu();

    // Default vars
    let trigger = $('.js-trigger-header'),
        header = $('.header'),
        scroll = $(window).scrollTop();

    // Trigger Header
    that.stickyHeader(scroll, trigger, header);

    // Trigger Dropdown
    that.triggerHeaderDropdown(trigger, header);

    $(document).on('scroll resize', function(){
      scroll = $(window).scrollTop();

      // Trigger Header
      that.stickyHeader(scroll, trigger, header);
    });
  }

  stickyHeader(scroll, trigger, header) {
    let outerWidth = $(window).outerWidth(),
        bar = header.find('.header-bar'),
        toggle = header.find('.header-toggle');

    if (scroll < 10) {
      // Enabled submenu
      header.find('.header-submenu').addClass('-show');

      // Sticky
      bar.removeClass('-sticky');
      toggle.removeClass('-sticky');
    } else {
      // Disabled submenu
      header.find('.header-submenu').removeClass('-show');

      // Sticky
      bar.addClass('-sticky');
      toggle.addClass('-sticky');
    }

    this.triggerHeaderColor(trigger, header);

    if(outerWidth <= 1024) {
      if (scroll >= 10) {
        header.addClass('-inverse');
      } else {
        header.removeClass('-inverse');
        this.triggerHeaderColor(trigger, header);
      }
    }
  }

  triggerHeaderDropdown(trigger, header) {
    const that = this;

    let body = $('.body');

    $('.dropdown').on('shown.bs.dropdown', function () {
      let dropdown = $(this);

      // Toggle arrow
      dropdown.find('.dropdown-toggle').addClass('icon-up-after').removeClass('icon-down-after');

      // Remove -inverse class
      header.removeClass('-inverse');

      // Enable overlay
      body.addClass('-overlay');
    });

    $('.dropdown').on('hidden.bs.dropdown', function () {
      let dropdown = $(this);

      // Toggle arrow
      dropdown.find('.dropdown-toggle').removeClass('icon-up-after').addClass('icon-down-after');

      // Trigger header color
      that.triggerHeaderColor(trigger, header);

      // Disable overlay
      body.removeClass('-overlay');
    });

    $(document).on('click', function (e) {
      let container = $('.header-submenu .dropdown');

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        body.removeClass('-overlay');
      }
    });
  }

  triggerHeaderColor(trigger, header) {
    trigger.each(function () {
      let section = $(this),
          elementTop = section.offset().top,
          viewportTop = $(window).scrollTop();

      if(viewportTop >= elementTop) {
        let headerType = section.data('header');

        if (headerType === 'inverse') {
          header.addClass('-inverse');
        } else if (headerType === 'default') {
          header.removeClass('-inverse');
        }
      }
    });
  }
}

export default Header;
